// アプリ一覧
import ReportForm from './routes/ReportForm.svelte'
import YokotaReportComposer from './routes/YokotaReportComposer.svelte'
import YokotaMonthlyView from './routes/YokotaMonthlyView.svelte'
import ReportSummary from './routes/ReportSummary.svelte'
import ManagementMenu from './routes/ManagementMenu.svelte'
import InspectionForm from './routes/InspectionForm.svelte'
import DriveReportComposer from './routes/DriveReportComposer.svelte'
import MonthlyRouteLogs from './routes/MonthlyRouteLogs.svelte'
import FormResponse from './routes/FormResponse.svelte'
import Stores from './routes/Stores.svelte'

export const APP_LIST = [
  {
    component: ReportForm,
    path: 'report-form',
    label: '作業日報 入力',
    description: '現場ごとの1日の作業報告',
  },
  {
    component: YokotaReportComposer,
    path: 'yokota-report-form',
    label: '横田工業 日報 入力',
    description: '横田工業様専用の作業報告',
    isSecret: true,
  },
  {
    component: YokotaMonthlyView,
    path: 'yokota-monthly-view',
    label: '横田工業 日報 一覧',
    description: '横田工業様の月次の日報の一覧',
    isSecret: true,
  },
  {
    component: ReportSummary,
    path: 'report-summary',
    label: '作業日報 サマリ',
    description: '作業日報の提出状況の確認',
    isSecret: true,
  },
  {
    component: InspectionForm,
    path: 'inspection-form',
    label: '点検 入力',
    description: '運行業務時の日常点検基準表の入力',
  },
  {
    component: DriveReportComposer,
    path: 'drive-report-composer',
    label: '運転日報 編集',
    description: '運転日報の編集',
  },
  {
    component: MonthlyRouteLogs,
    path: 'monthly-route-logs',
    label: '月次 走行記録',
    description: '運転日報の走行記録の月ごとの一覧',
  },
  {
    component: FormResponse,
    path: 'form-response',
    label: '送信完了画面',
    description: 'フォーム送信後の結果画面',
    isSecret: true,
  },
  {
    component: ManagementMenu,
    path: 'management-menu',
    label: '管理メニュー',
    description: '管理者用の専用画面',
    isSecret: true,
  },
  {
    component: Stores,
    path: 'stores',
    label: 'ストア一覧',
    description: '',
    isSecret: true,
  },
]
